import type { ReactNode } from 'react';

import sbgLogoNavy from '../assets/sbg-logo-navy.png';
import sbgLogoWhite from '../assets/sbg-logo-white.png';

interface MarkProps {
  readonly tone?: 'navy' | 'white';
  readonly className?: string;
  readonly compact?: boolean;
}

export function BrandMark({ tone = 'navy', className = '', compact = false }: MarkProps): ReactNode {
  return (
    <span className={`inline-flex items-center ${className}`}>
      <img
        src={tone === 'white' ? sbgLogoWhite : sbgLogoNavy}
        alt="Silver Bell Group"
        className={compact ? 'h-5 w-auto' : 'h-8 w-auto'}
      />
    </span>
  );
}
